var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price_visible !== 0)?_c('tr',[_c('td',{staticClass:"price_value"},[(_vm.price_visible !== 0)?_c('div',[_vm._v(_vm._s(_vm.price_visible))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"em_tip"},[_vm._v(_vm._s(_vm.ru_za))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }